<template>
  <gp-tooltip :visible="!!patch">
    <template v-if="patch">
      <div class="gpa-patch-tooltip">
        <div class="gpa-patch-tooltip__header">
          <span class="gpa-patch-tooltip__title">{{ patch.displayName }}</span>
          <template v-if="!hasElements">&nbsp;({{ $t('js.generic.empty') }})</template>
        </div>

        <ul v-if="hasElements" class="gpa-patch-tooltip__list">
          <li v-for="element in elements" :key="element.id">{{ element.displayName }}</li>
        </ul>
      </div>
    </template>
  </gp-tooltip>
</template>

<script>
import Patch from '../../../../classes/models/Patch'
import GpTooltip from '../../../../../vue/common/Tooltip/Tooltip.vue'

export default {
  name: 'GpaPatchTooltip',
  components: { GpTooltip },
  props: {
    patch: { required: false, type: Patch, default: null },
  },
  computed: {
    hasElements () { return this.elements.length > 0 },
    elements () { return this.patch.activeElements },
  },
}
</script>
